import ReactDOM from "react-dom";
import Landing from "../src/pages/Landing";
import { post } from "./code/api";
import { urlRedirect } from "./code/common";
import { AuthorisationContext } from "@sal/react.authentication";
import { BookingContextProvider } from "./components/BookingContextProvider";
import { servicePath } from "./components/Settings";
import "./styles/style.scss";

const queryParams = new URLSearchParams(window.location.search);
const jwt = queryParams ? queryParams.get("id_token") : null;
const jsonState = queryParams ? queryParams.get("state") : null;
const state = queryParams && jsonState ? JSON.parse(jsonState) : null;

function cvLogin() {
	post(servicePath + "account/login", { "jwt": jwt, "AccountID": state.accountID })
		.then(response => {
			localStorage["salauth"] = JSON.stringify(response.contactName || "");
			urlRedirect(jwt, state, () => { });
		});
}
var isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Macintosh/i);

var eventName = isOnIOS ? "pagehide" : "beforeunload";
window.addEventListener(eventName, function () {
	sessionStorage.removeItem("__lock");
});

if (sessionStorage.getItem("__lock")) {
	sessionStorage.removeItem("booking");
}

sessionStorage.setItem("__lock", "1");
ReactDOM.render(
	<AuthorisationContext settings={{ thirdPartyAuthFunction: cvLogin }}>
		<BookingContextProvider>
			<Landing />
		</BookingContextProvider>
	</AuthorisationContext>,
	document.getElementById("root")
);
